import { gql } from '@apollo/client';

export const ACCOUNT_SUBSCRIPTION_INFO = gql`
  query accountSubscriptionInfo($hash: String) {
    accountSubscriptionInfo(hash: $hash) {
      id
      subscriptions {
        id
        isSmsSubscribedYau
        isEmailSubscribed
        notificationId
        franchiseId
        notification {
          name
        }
      }
      affiliations {
        id
        name
        code
      }
    }
  }
`;
